import React from "react";
import "./stars.scss";
import Typed from "react-typed";
import pdfFile from "../yves.pdf";

function Intro() {
  const showPdf = () => {
    window.open(pdfFile);
  };
  return (
    <div>
      <div id="home" className="intro route background-hero">
        {/* <div id="stars" />
        <div id="stars2" />
        <div id="stars3" /> */}

        <div className="intro-content display-table">
          <div className="table-cell">
            <div className="container">
              <h1 className="intro-title mb-4">
                Hi, I'm John Yves Marin
                <span className="wave">
                  <img
                    className="wave-hand"
                    alt=""
                    draggable="false"
                    src="https://www.pngkey.com/png/full/148-1485816_wave-emoji-png.png"
                  />
                </span>
              </h1>
              <p className="intro-subtitle">
                <span className="text-slider-items"></span>
                <strong className="text-slider">
                  <Typed
                    strings={[
                      "Web Developer",
                      "Empowering your web identity",
                      "I develop websites that help businesses",
                    ]}
                    typeSpeed={80}
                    backDelay={1100}
                    backSpeed={30}
                    loop
                  />
                </strong>
              </p>
              <div className="d-flex justify-content-center mt-5">
                <p className="p-3">
                  <a
                    className="btn btn-primary btn js-scroll px-4"
                    href="#work"
                    role="button"
                  >
                    Show Projects
                  </a>
                </p>
                <p className="p-3">
                  <button
                    className="btn btn-secondary btn js-scroll px-4"
                    onClick={showPdf}
                  >
                    View Resume
                  </button>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Intro;
